'use client';
import classNames from 'classnames';
import React, { MouseEvent, useEffect, useRef, useState } from 'react';
import { useIsOnline } from '../context/online';
import useGlossary from '../hooks/use-glossary/use-glossary';

export interface TextHtmlProps {
    html: any;
    mode?: 'light' | 'dark';
    linkColor?: string;
    // in app path the glossary should return to when opened from a term in this text
    backTo?: string;
}

export function TextHtml(props: TextHtmlProps & React.HTMLAttributes<HTMLDivElement>) {
    const { html, mode = 'light', className = '', linkColor, backTo, style, ...rest } = props;
    const [loaded, setLoaded] = useState(false);
    const textRef = useRef<HTMLDivElement>(null);
    const isOnline = useIsOnline();
    useGlossary({ ref: textRef, rerenderTrigger: loaded, backTo });

    useEffect(() => {
        setLoaded(true);
    }, []);

    const glossaryLinkColor = classNames({
        'html-block--light': mode === 'light',
        'html-block--dark': mode === 'dark',
        'html-block--custom-link': !!linkColor,
    });

    const contentClickHandler = (e: MouseEvent) => {
        if (!isOnline) {
            e.preventDefault();
        }
    };

    return (
        <div
            key={loaded.toString()}
            className={`${className} ${glossaryLinkColor}`}
            {...rest}
            ref={textRef}
            style={linkColor ? ({ ...style, '--link-color': linkColor } as React.CSSProperties) : style}
            onClick={contentClickHandler}
            dangerouslySetInnerHTML={{ __html: html }}
        />
    );
}

export default TextHtml;
